import {
    MinusSquare,
    PlusSquare
} from "../../../../ApplicationBuilder/ApplicationDesigner/ApplicationTree/Tree/TreeUtils";
import React, {useCallback} from "react";
import {TreeView} from "@material-ui/lab";
import {makeStyles} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {useDeepCompareEffect, useDeepCompareMemo} from "use-deep-compare";
import {getParamsFromString} from "../../../Utils";
import RenderTreeVertical from "./TreeVertical/RenderTreeVertical";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import RenderTreeHorizontal from "./TreeHorizontal/RenderTreeHorizontal";
import {Tree} from "react-organizational-chart";
import StyledTreeItemHorizontal from "./TreeHorizontal/StyledTreeItemHorizontal";

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        flexGrow: 1,
        maxWidth: 350,
        width: '100%'
    },
    container: {
        padding: 10,
        width: '100%'
    }
}))
const useComponentEvents = (events) => {
    const [availableEvents, setAvailableEvents] = React.useState({});
    useDeepCompareEffect(() => {
        let tmp = {};
        events.forEach(event => {
            if (event.event) {
                if (event.actions) {
                    tmp[event.event] = event.actions
                }
            }
        })
        setAvailableEvents(tmp)
    }, [events])

    return availableEvents;
}
const TreeComponent = (props) => {
    const {
        component: {children = [], properties: {childrenKey, path, variant}, events},
        actionsContext, screenName, doActions
    } = props;
    const [rootItem, childItem] = children;
    const [selectedNodes, setSelectedNodes] = React.useState([]);
    const [expandedNodes, setExpandedNodes] = React.useState([]);
    const globalValues = useSelector(state => state.jsonScreen.globalValues);
    const currentValues = useDeepCompareMemo(() => {
        return getParamsFromString(`{${path}}`, {...globalValues, ...actionsContext}, screenName);
    }, [globalValues, path])
    const {onDoubleClick} = useComponentEvents(events);
    const classes = useStyles();
    const onDoubleClickHandler = useCallback((doc) => {
        onDoubleClick && (
            doActions(onDoubleClick, {doc})
        )

    }, [onDoubleClick])

    function handleSelect(event, nodesId) {
        setSelectedNodes(nodesId)
    }
    function handleToggle(event, nodesId) {
        setExpandedNodes(nodesId)
    }
    if(variant === 'horizontal') {
        return(
            <Tree label={<StyledTreeItemHorizontal
                component={rootItem}
                doc={currentValues[childrenKey]?.[0] || {}}
                onDoubleClick={onDoubleClickHandler}
            />}>
                {RenderTreeHorizontal({
                    sourceData: currentValues[childrenKey]?.[0] || [],
                    childrenKey,
                    rootItem,
                    childItem,
                    onDoubleClick: onDoubleClickHandler
                })}
            </Tree>
        )
    }
    return (
        <TreeView
            className={classes.root}
            defaultExpanded={['0']}
            defaultCollapseIcon={<MinusSquare/>}
            defaultExpandIcon={<PlusSquare/>}
            // defaultEndIcon={<CloseSquare/>}
            expanded={expandedNodes}
            selected={selectedNodes}
            onNodeToggle={handleToggle}
            onNodeSelect={handleSelect}
        >
            {RenderTreeVertical({
                sourceData: currentValues,
                childrenKey,
                rootItem,
                childItem,
                onDoubleClick: onDoubleClickHandler
            })}
        </TreeView>

    )
}

export default JsonScreenHoc(TreeComponent);
